// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__J2hdE"};